import { useTranslation } from 'react-i18next'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcn/select'
import { HelpLabel } from '@/components/common/help/HelpLabel'
import { helpKey } from '@/lib/action-modules/help'
import { ActionModuleFrequency, isRepeatPatternSchedulingStrategyModel, type RepeatPatternSchedulingStrategyModel, type SchedulingStrategyEditorProps } from '@/lib/action-modules/registry/scheduling/types'

export default function RepeatPatternEditor(props: SchedulingStrategyEditorProps) {
  const { t } = useTranslation('action-modules-wizard')
  const rp = (key: string) => t(`schedulingStrategy.repeatPattern.${key}`)
  const value = props.value
  if (!isRepeatPatternSchedulingStrategyModel(value)) return <>{t('editor.invalidValue')}</>

  return (
    <div className="flex max-w-md flex-col gap-2">
      <HelpLabel helpKey={helpKey('schedulingRepeatPatternFrequency')}>{rp('frequency')}</HelpLabel>
      <Select
        disabled = {props.disabled}
        value={value.frequency}
        onValueChange={v =>
          props.onChanged({ ...value, frequency: v as ActionModuleFrequency } as RepeatPatternSchedulingStrategyModel)
        }
      >
        <SelectTrigger className="w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ActionModuleFrequency.Daily}>{rp('daily')}</SelectItem>
          <SelectItem value={ActionModuleFrequency.Weekly}>{rp('weekly')}</SelectItem>
          <SelectItem value={ActionModuleFrequency.Monthly}>{rp('monthly')}</SelectItem>
          <SelectItem value={ActionModuleFrequency.Yearly}>{rp('yearly')}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
